module.exports = __webpack_public_path__ + "static/girls-typing-5a2a85b103c426935e68682a8192129d.jpg";